<script>
export default {
  name: 'SelectableList',
  props: {
    items: Array,
    autoreset: Boolean,
  },
  data() {
    return {
      state: 'none',
      valueToSet: true,
      startIndex: 0,
      lastIndex: 0,
      checked: new Set(),
    };
  },
  watch: {
    checked(val) {
      this.$emit('change', [...val]);
    },
    items() {
      if (!this.autoreset) return;
      this.checked = new Set();
    },
  },
  mounted() {
    document.addEventListener('mouseup', this.mouseup);
  },
  beforeDestroy() {
    document.removeEventListener('mouseup', this.mouseup);
  },
  methods: {
    reset() {
      this.checked = new Set();
    },
    enter(i) {
      if (this.state !== 'selecting') return;
      this.setArray(i);
    },
    leave(i) {
      if (this.state !== 'down') return;
      this.state = 'selecting';
      this.valueToSet = this.checked.has(i);
      this.startIndex = i;
      this.lastIndex = i;
      this.setArray(i);
    },
    down() {
      if (this.state !== 'none') return;
      this.state = 'down';
    },
    mouseup() {
      this.state = 'none';
    },
    selectAll(value) {
      if (!value) {
        this.checked = new Set();
        return;
      }

      this.startIndex = 0;
      this.setArray(this.items.length - 1);
    },
    setArray(toIndex) {
      const from = Math.min(this.startIndex, toIndex);
      const to = Math.max(this.startIndex, toIndex);

      for (let i = from; i <= to; i += 1) {
        // eslint-disable-next-line
        this.valueToSet
          ? this.checked.add(i)
          : this.checked.delete(i);
      }

      this.checked = new Set([...this.checked]);
    },
    toggle(i, { shift }) {
      if (shift) {
        this.startIndex = this.lastIndex;
        this.setArray(i);
        return;
      }

      this.valueToSet = !this.checked.has(i);
      this.lastIndex = i;

      // eslint-disable-next-line
      this.checked.has(i)
        ? this.checked.delete(i)
        : this.checked.add(i);

      this.checked = new Set([...this.checked]);
    },
  },
};
</script>

<template lang="pug">
.b-selectable-list(:class="{ isSelecting: this.state === 'selecting' }")
  slot(
    :items="items"
    :checked="checked"
    :toggle="toggle"
    :enter="enter"
    :leave="leave"
    :down="down"
  )
</template>

<style scoped lang="scss">
.selectable-list.isSelecting {
  user-select: none;
}
</style>
